module.exports = __webpack_public_path__ + "img/1.992578f9.png";